// client/src/utils/datetime.js
// 全站時間顯示統一入口。
// 後端時間戳一律是 UTC ISO（...Z）；這裡預設用「瀏覽器自動偵測到的使用者時區」
// （Intl 解析的 timeZone）把它轉成當地時間顯示 —— 台灣使用者看台北、其他時區看當地。
// 需要強制某個固定時區（例如後台想一律台北）時，傳 opts.tz 覆寫。
//
// ⚠️ 只可用在「後端來的 UTC 瞬間」；使用者自己在日期選擇器挑的裸日期字串（如 "2026-07-27"）
//    不要丟進來（那不是 UTC 瞬間、轉時區反而會位移）。

const DEFAULT_LOCALE = "zh-TW"; // 純數字格式為主，與語系無強相依（2026/07/27 11:41）

// 瀏覽器偵測到的使用者時區（除錯 / 需要顯示時區名稱時用）
export function getUserTimeZone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch {
    return "";
  }
}

function toDate(value) {
  if (value == null || value === "") return null;
  const d = value instanceof Date ? value : new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

// 日期＋時間：2026/07/27 11:41（withSeconds → 加秒）
export function fmtDateTime(value, { tz, withSeconds = false, locale = DEFAULT_LOCALE } = {}) {
  const d = toDate(value);
  if (!d) return "-";
  return d.toLocaleString(locale, {
    ...(tz ? { timeZone: tz } : {}), // 不傳 tz → 用瀏覽器本地（＝自動偵測使用者時區）
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    ...(withSeconds ? { second: "2-digit" } : {}),
    hourCycle: "h23", // 0–23；避免 zh-TW 在午夜顯示成 24:00
  });
}

// 只到日期：2026/07/27
export function fmtDate(value, { tz, locale = DEFAULT_LOCALE } = {}) {
  const d = toDate(value);
  if (!d) return "-";
  return d.toLocaleDateString(locale, {
    ...(tz ? { timeZone: tz } : {}),
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
}
